import { Environment } from 'environments/environment.interface';

export const environment: Environment = {
  production: true,
  serverUrl: 'https://r.projcont.novin.hu',
  mockServerUrl: '',
  infoMessageDuration: 3,
};
